import React, { useState } from "react";
import firebase from "../../../utils/firebase";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { registerUser } from "../../../slices/authSlice";
import { setAlert } from "../../../slices/alertSlice";
import { Link, useHistory } from "react-router-dom";
import {
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import Button from "../../../components/MaterialKit/CustomButtons/Button";

import CardBody from "components/MaterialKit/Card/CardBody.js";
import CardHeader from "components/MaterialKit/Card/CardHeader.js";

import CardFooter from "components/MaterialKit/Card/CardFooter";
import { REGISTER } from "../../../constants/routes";
const useStyles = makeStyles(styles);

const AutoRegister = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { displayName, email, photoURL, uid } = firebase.auth().currentUser;
  const [formData, setFormdata] = useState({
    name: displayName,
    username: "",
    email: email,
    password: uid,
    photo: photoURL,
    method: "auto-register",
  });
  const {
    auth: { loading },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  const { username } = formData;
  const handleChange = (e) => {
    setFormdata({ ...formData, username: e.target.value });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    if (username === "")
      dispatch(setAlert("Please enter your username", "warning"));
    else {
      dispatch(registerUser(formData, history));
    }
  };
  const classes = useStyles();
  return (
    <form onSubmit={onSubmit} className={classes.form}>
      <CardHeader color="black" className={classes.cardHeader}>
        <h3>Welcome {firebase.auth().currentUser.displayName}</h3>
      </CardHeader>

      <CardBody>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Name"
            placeholder="Username"
            name="username"
            value={username}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-user" />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </CardBody>
      <CardFooter>
        <Button type="submit" color="warning" round fullWidth loading={loading}>
          Register
        </Button>
      </CardFooter>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          padding: "1rem",
        }}
      >
        <div
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Link
            to={REGISTER}
            style={{
              textDecoration: "none",
            }}
          >
            <Button
              onClick={() => {
                firebase.auth().signOut();
              }}
              simple
              variant="contained"
              color="primary"
              size="lg"
            >
              Back
            </Button>
          </Link>
        </div>
      </div>
    </form>
  );
};

export default AutoRegister;
